import Popover from 'antd/lib/popover';
import Space from 'antd/lib/space';
import Link from 'antd/lib/typography/Link';
import * as React from 'react';
import { StabilityIssue } from '../../types';
import { antGrey, hexStringToRGBAString, runwayColors, tagStyle } from '../styles/globalStyles';
import Tag from 'antd/lib/tag';
import commitNode from '../../../assets/commit-node.svg';
import Text from 'antd/lib/typography/Text';
import Button from 'antd/lib/button';
import { ArrowRightOutlined } from '@ant-design/icons';
import Tooltip from 'antd/lib/tooltip';

interface StabilityIssueProps {
    issue: StabilityIssue;
    showNew: boolean;
    showTotal: boolean;
    onShowIssueDrawer: (issue: StabilityIssue) => void;
}

const StabilityIssueItem: React.FC<StabilityIssueProps> = (props: StabilityIssueProps) => {
    const { issue, showNew, showTotal } = props;
    const [showDescriptionPopover, setShowDescriptionPopover] = React.useState(false);
    const hasAssociatedCommits = issue.associatedCommits?.length > 0;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, width: '100%' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    minWidth: 0,
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', minWidth: 0, gap: 8 }}>
                    <Space align="center" style={{ minWidth: 0 }} className="stab-issue-space">
                        <Space size={3}>
                            <Link href={issue.url} target="_blank" strong ellipsis>
                                {issue.crashShortDescription}
                            </Link>
                            {hasAssociatedCommits && (
                                <Tooltip title="Suspect commit identified.">
                                    <img style={{ color: runwayColors.statusRed }} src={commitNode} />
                                </Tooltip>
                            )}
                        </Space>
                        <Popover
                            color={hexStringToRGBAString(antGrey.grey10, 0.9)}
                            content={
                                showDescriptionPopover ?
                                    <div
                                        style={{
                                            maxWidth: 600,
                                            maxHeight: 245,
                                            overflowY: 'scroll',
                                        }}
                                    >
                                        <code style={{ color: 'white' }}>{issue.crashLongDescription}</code>
                                    </div>
                                :   undefined
                            }
                            overlayClassName="stab-issue-popover"
                        >
                            <Text style={{ color: antGrey.grey8 }} ellipsis={{ onEllipsis: setShowDescriptionPopover }}>
                                {issue.crashLongDescription}
                            </Text>
                        </Popover>
                    </Space>
                    {issue.isNewInRelease && showNew && (
                        <Tag
                            color={runwayColors.statusYellow}
                            style={{
                                ...tagStyle,
                                fontSize: 11,
                                fontWeight: 500,
                                marginLeft: 16,
                                padding: 4,
                                lineHeight: '11px',
                            }}
                        >
                            New
                        </Tag>
                    )}
                </div>
                <Space size={16}>
                    <Space style={{ flexShrink: 0, marginLeft: 34 }} align="center" size={6}>
                        <Text style={{ color: antGrey.grey8, fontSize: 14 }}>{issue.occurrencesCountInRelease}</Text>
                        {showTotal && (
                            <>
                                <Text style={{ fontSize: 14, color: antGrey.grey6 }}>/</Text>
                                <Text style={{ fontSize: 14, color: antGrey.grey6 }}>
                                    {issue.totalOccurrencesCount}
                                </Text>
                            </>
                        )}
                    </Space>
                    <Button onClick={() => props.onShowIssueDrawer(issue)} type="link" style={{ padding: 0 }}>
                        <ArrowRightOutlined style={{ color: runwayColors.primary }} />
                    </Button>
                </Space>
            </div>
            {issue.blameFile && issue.blameLine && (
                <Text style={{ color: antGrey.grey7 }} ellipsis>
                    {issue.blameFile}:{issue.blameLine}
                </Text>
            )}
        </div>
    );
};

export default StabilityIssueItem;
